import * as React from "react";
const SvgComponent = ({ fill, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M9.524 20.457a1 1 0 0 1 1.241.678 1.03 1.03 0 0 0 1.975 0 1 1 0 1 1 1.919.563 3.03 3.03 0 0 1-5.813 0 1 1 0 0 1 .678-1.241ZM11.75 0a1 1 0 0 1 1 1v2.188a1 1 0 1 1-2 0V1a1 1 0 0 1 1-1Z"
      clipRule="evenodd"
    />
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M11.75 4.188a6.292 6.292 0 0 0-6.292 6.291c0 3.157-.373 5.26-.77 6.603-.044.148-.088.288-.132.418h14.307a9.188 9.188 0 0 1-.045-.14c-.406-1.277-.776-3.393-.776-6.88a6.292 6.292 0 0 0-6.292-6.293Zm0-2a8.292 8.292 0 0 0-8.292 8.291c0 3.001-.355 4.91-.688 6.037a6.897 6.897 0 0 1-.435 1.146 2.536 2.536 0 0 1-.135.237A1 1 0 0 0 3 19.5h17.5a1 1 0 0 0 .683-1.73.994.994 0 0 1-.065-.093c-.084-.134-.233-.414-.394-.921-.323-1.02-.682-2.915-.682-6.277a8.292 8.292 0 0 0-8.292-8.291Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
